<template>
<svg viewBox="0 0 34 34" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ShouYeXuanZhong4`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.3762 6.42496L7.57859 12.0699C6.53947 12.8222 5.92419 14.0272 5.92419 15.31V24.3354C5.92419 26.5446 7.71506 28.3354 9.92419 28.3354H14.2238V21.1464C14.2238 20.5942 14.6715 20.1464 15.2238 20.1464H16.6833C18.8924 20.1464 20.6833 21.9373 20.6833 24.1464V28.3354H25C27.2091 28.3354 29 26.5446 29 24.3354V15.2419C29 13.9974 28.4207 12.8238 27.4329 12.0668L20.1547 6.48997C18.7513 5.41461 16.8084 5.38818 15.3762 6.42496Z"/><defs><linearGradient id="svg_e030ef9cb4__paint0_linear_1080_3341" x1="17.462" y1="4.679" x2="17.462" y2="28.336" gradientUnits="userSpaceOnUse"><stop stop-color="#C37FFD"/><stop offset="1" stop-color="#A75AEA"/></linearGradient></defs></svg>
</template>
<script>

export default {
  name: 'IconShouYeXuanZhong4',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
